/** Illustrative sample data for Keywords Management (Screen 1 & 2). */

export const KEYWORDS_DUMMY_DATA = [
  {
    id: 'KEY-0006',
    keyword: 'Emergency Plumbing',
    tradeCategoryId: 'TC-001',
    tradeCategoryName: 'Plumbing',
    subcategoryId: '',
    subcategoryName: 'Pool',
    isPool: true,
    status: 'Active',
    activePostCount: 6,
    soleActiveKeywordPostCount: 0,
    createdOn: '8 Feb 2025, 8:10 am',
    createdBy: 'Saim Sahi',
    lastUpdatedOn: '12 Jul 2026, 9:00 am',
    lastUpdatedBy: 'Saim Sahi',
  },
  {
    id: 'KEY-0007',
    keyword: 'General Plumbing',
    tradeCategoryId: 'TC-001',
    tradeCategoryName: 'Plumbing',
    subcategoryId: '',
    subcategoryName: 'Pool',
    isPool: true,
    status: 'Active',
    activePostCount: 4,
    soleActiveKeywordPostCount: 0,
    createdOn: '8 Feb 2025, 8:15 am',
    createdBy: 'Saim Sahi',
    lastUpdatedOn: '12 Jul 2026, 9:05 am',
    lastUpdatedBy: 'Amelia Chen',
  },
  {
    id: 'KEY-0008',
    keyword: 'Licensed Plumber',
    tradeCategoryId: 'TC-001',
    tradeCategoryName: 'Plumbing',
    subcategoryId: '',
    subcategoryName: 'Pool',
    isPool: true,
    status: 'Active',
    activePostCount: 2,
    soleActiveKeywordPostCount: 0,
    createdOn: '8 Feb 2025, 8:20 am',
    createdBy: 'Saim Sahi',
    lastUpdatedOn: '12 Jul 2026, 9:10 am',
    lastUpdatedBy: 'Noah Williams',
  },
  {
    id: 'KEY-0001',
    keyword: 'Blocked Drain Clearing',
    tradeCategoryId: 'TC-001',
    tradeCategoryName: 'Plumbing',
    subcategoryId: 'SC-002',
    subcategoryName: 'Drainage Plumbing',
    status: 'Active',
    activePostCount: 14,
    soleActiveKeywordPostCount: 2,
    createdOn: '10 Feb 2025, 9:20 am',
    createdBy: 'Saim Sahi',
    lastUpdatedOn: '18 Jul 2026, 2:40 pm',
    lastUpdatedBy: 'Amelia Chen',
  },
  {
    id: 'KEY-0002',
    keyword: 'Gas Connection',
    tradeCategoryId: 'TC-001',
    tradeCategoryName: 'Plumbing',
    subcategoryId: 'SC-004',
    subcategoryName: 'Gas Fitting',
    status: 'Active',
    activePostCount: 8,
    soleActiveKeywordPostCount: 1,
    createdOn: '14 Feb 2025, 11:05 am',
    createdBy: 'Saim Sahi',
    lastUpdatedOn: '6 May 2026, 10:15 am',
    lastUpdatedBy: 'Saim Sahi',
  },
  {
    id: 'KEY-0003',
    keyword: 'Gas Stove Installation',
    tradeCategoryId: 'TC-001',
    tradeCategoryName: 'Plumbing',
    subcategoryId: 'SC-004',
    subcategoryName: 'Gas Fitting',
    status: 'Active',
    activePostCount: 5,
    soleActiveKeywordPostCount: 0,
    createdOn: '14 Feb 2025, 11:10 am',
    createdBy: 'Saim Sahi',
    lastUpdatedOn: '2 Jun 2026, 4:25 pm',
    lastUpdatedBy: 'Noah Williams',
  },
  {
    id: 'KEY-0009',
    keyword: 'Gas Leak Repair',
    tradeCategoryId: 'TC-001',
    tradeCategoryName: 'Plumbing',
    subcategoryId: 'SC-004',
    subcategoryName: 'Gas Fitting',
    status: 'Active',
    activePostCount: 2,
    soleActiveKeywordPostCount: 0,
    createdOn: '14 Feb 2025, 11:18 am',
    createdBy: 'Saim Sahi',
    lastUpdatedOn: '4 Jun 2026, 1:10 pm',
    lastUpdatedBy: 'Amelia Chen',
  },
  {
    id: 'KEY-0004',
    keyword: 'Hot Water System Installation',
    tradeCategoryId: 'TC-001',
    tradeCategoryName: 'Plumbing',
    subcategoryId: 'SC-003',
    subcategoryName: 'Hot Water Systems',
    status: 'Inactive',
    activePostCount: 0,
    soleActiveKeywordPostCount: 0,
    createdOn: '22 Feb 2025, 1:15 pm',
    createdBy: 'Saim Sahi',
    lastUpdatedOn: '22 Jul 2026, 10:30 am',
    lastUpdatedBy: 'Amelia Chen',
  },
];

export const buildSampleKeywords = () => KEYWORDS_DUMMY_DATA.map((k) => ({ ...k }));

/** Extended sample data for Configuration — Keyword Relationship Rules testing. */
export const KEYWORDS_RELATIONSHIP_SAMPLE_DATA = [
  ...KEYWORDS_DUMMY_DATA,
  {
    id: 'KEY-0005',
    keyword: 'Gas Meter Work',
    tradeCategoryId: 'TC-001',
    tradeCategoryName: 'Plumbing',
    subcategoryId: 'SC-004',
    subcategoryName: 'Gas Fitting',
    status: 'Active',
    activePostCount: 3,
    soleActiveKeywordPostCount: 0,
    createdOn: '14 Feb 2025, 11:20 am',
    createdBy: 'Saim Sahi',
    lastUpdatedOn: '14 Feb 2025, 11:20 am',
    lastUpdatedBy: 'Saim Sahi',
  },
];

export const buildSampleKeywordsForRelationshipTests = () =>
  KEYWORDS_RELATIONSHIP_SAMPLE_DATA.map((k) => ({ ...k }));
